import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiDiverse {
    constructor() {

    }

    activeObjects() {
    }

    autoSuspend() {
    }

    createProcess() {
    }

    debugObjects() {
    }
}
